import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
import { BRAND_CART_WIDTH_WIDE } from "./consts";
export var INNER_MAKER_CONTAINER_MAX_WIDTH = 1600;
export var getInnerMakerContainerMaxWidthXLargeAndAbove = function() {
    return "".concat(INNER_MAKER_CONTAINER_MAX_WIDTH, "px - ").concat(BRAND_CART_WIDTH_WIDE.xlarge);
};
export var InnerMakerContainer = styled.div.withConfig({
    componentId: "sc-46dcab1c-0"
})([
    "margin-left:auto;margin-right:auto;",
    "{max-width:calc(",
    ");}"
], responsiveMediaQueries.xLargeAndAbove, getInnerMakerContainerMaxWidthXLargeAndAbove());
